import { render, staticRenderFns } from "./currency-format.vue?vue&type=template&id=8d8c914c&"
import script from "./currency-format.vue?vue&type=script&lang=js&"
export * from "./currency-format.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports